export const routerPath = {
  root: '/allProducts',
};

export const getColumns = () => [
  {
    id: 'defaultImageId',
    type: 'avatar',
    label: 'Image',
    align: 'center',
    disableSort: true,
  },
  { id: 'name', label: 'Product', align: 'left', nameForSort: 'name' },
  { id: 'brandName', label: 'Brand', align: 'left', nameForSort: 'brand_name' },
  { id: 'vendorName', label: 'Vendor', align: 'left', nameForSort: 'vendor_name' },
  { id: 'barcode', label: 'Barcode', align: 'center', nameForSort: 'barcode' },
  {
    id: 'active',
    label: 'Status',
    customValue: (val) => (val.active ? 'Active' : 'Inactive'),
    align: 'center',
    nameForSort: 'active',
  },
  {
    id: 'category',
    label: 'Category',
    align: 'center',
    nameForSort: 'category',
  },
  {
    id: 'subcategory',
    label: 'Subcategory',
    align: 'center',
    nameForSort: 'subcategory',
  },
  {
    id: 'gender',
    label: 'Gender',
    align: 'center',
    customValue: (val) => (val?.gender ? val?.gender : ''),
    disableSort: true,
  },
  {
    id: 'recommendedRetailPrice',
    label: 'Recommended Retail Price',
    align: 'center',
    nameForSort: 'recommended_retail_price',
  },
  {
    id: 'redeemableCoins',
    label: 'Redeemable Coins',
    align: 'center',
    nameForSort: 'redeemable_coins',
  },
  {
    id: 'redeemableCoinValue',
    label: 'Redeemable Coin Value',
    align: 'center',
    nameForSort: 'redeemable_coin_value',
  },
  {
    id: 'allowedMargin',
    label: 'Allowed Margin %',
    align: 'center',
    disableSort: true,
  },
];

export const getFilters = ({ active, searchBy, category, subCategory, options, vendor, brand }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Search by Name, Vendor, Brand',
    action: searchBy.change,
  },
  {
    id: 'category',
    type: 'select',
    label: 'Category',
    value: category.value,
    action: category.change,
    items: options?.categories?.length ? ['all', ...options.categories] : ['all'],
  },
  {
    id: 'vendors',
    type: 'select',
    label: 'Vendor',
    value: vendor.value,
    action: vendor.change,
    items: options?.vendors?.length ? ['all', ...options.vendors] : ['all'],
  },
  {
    id: 'brands',
    type: 'select',
    label: 'Brand',
    value: brand.value,
    action: brand.change,
    items: options?.brands?.length ? ['all', ...options.brands] : ['all'],
  },
  {
    id: 'subCategory',
    type: 'select',
    label: 'Subcategory',
    value: subCategory.value,
    action: subCategory.change,
    items: options?.subcategories?.length ? ['all', ...options.subcategories] : ['all'],
  },
  {
    id: 'active',
    type: 'switch',
    label: 'Active',
    value: active.value === 'true',
    action: active.change,
  },
];
